import {servelService} from "@/api/servelApi";
import {utils} from "@/utils";
import moment from 'moment-timezone'

const state = {
  loading: true,
  current: null,
  notExists: false,
  error: null
}

const actions = {
  getUser({commit}) {
    return new Promise((resolve, reject) => {
      commit('getUser')
      servelService.getRegistronombreapellido()
        .then(response => {
          if (response.data.statusCode === 200) {
            commit('getUserSuccess', response.data)
            resolve(true)
          } else {
            commit('getUserNotExists')
            resolve(true)
          }
        })
        .catch(error => {
          commit('getUserFailure', error)
          reject(false)
        });
    })
  }
}

const mutations = {
  getUser(mstate) {
    mstate.loading = true;
  },
  getUserSuccess(mstate, muser) {
    mstate.loading = false
    mstate.notExists = false
    const data = muser.datos

    if (data === null || Object.entries(data).length === 0) {
      mstate.current = null
      mstate.notExists = true
      return
    }

    mstate.current = data
    if (moment(data.fecha_nacimiento, "YYYYMMDD").isValid())
      mstate.current.fechaNacimiento = moment(data.fecha_nacimiento, "YYYYMMDD").toDate()
    mstate.current.rut = utils.rutFilter(`${data.cedula}-${data.dv}`)
    mstate.current.nombreCompleto = utils.capitalize(`${data.nombres} ${data.paterno} ${data.materno}`)
    mstate.current.firstLastName = utils.capitalize(`${data.nombres} ${data.paterno}`)
  },
  getUserNotExists(mstate) {
    console.log("getUserNotExists")
    mstate.loading = false
    mstate.current = null
    mstate.notExists = true
  },
  getUserFailure(mstate, error) {
    mstate.loading = false;
    mstate.error = error;
  },
}

export const user = {
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations
}
